<template src="./templates/print-contract.html" />
<script type="text/ecmascript-6">
import { mapGetters } from 'vuex'
import AnimationProcessing from 'components/animations/processing'
import Methods from 'src/pages/contract/script/common.methods'

export default {
  name: 'PrintContract',

  components: {
    AnimationProcessing
  },
  data () {
    return {}
  },

  methods: {
    ...Methods
  },

  computed: {
    ...mapGetters('contract', {
      contractHTML: ['printTemplate'],
      spinner: ['printTemplateSpinner']
    })
  },
  created () {
    this.$store.dispatch('contract/getPrintContractTemplate', this.getfIdFromRoute())
      .catch(() => { this.$router.push({ name: '403' }) })
  }
}
</script>
<style src="./stylesheets/index.scss" lang="scss" module></style>
<style src="./stylesheets/contract.scss" lang="scss" scoped></style>
